export default __webpack_public_path__ + "static/team-paulina-91bb630e3e4915b24c65b2fb7d3e2a52.png";